import { render, staticRenderFns } from "./ShippingRates.vue?vue&type=template&id=78021e84&scoped=true&"
import script from "./ShippingRates.vue?vue&type=script&lang=js&"
export * from "./ShippingRates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78021e84",
  null
  
)

export default component.exports